export default __webpack_public_path__ + "static/media/arrow_up.792c8c47.svg";